import 'react-datepicker/dist/react-datepicker.css';
import ReactDatePicker, { type DatePickerProps } from 'react-datepicker';
import i18n from '../utils/i18n';

type Props = DatePickerProps & {
	selectsRange?: never;
	selectsMultiple?: never;
	onChange: (value: Date | null) => void;
	colorScheme?: string;
	dataCy?: string;
};

export const DatePicker = ({
	timeFormat = 'HH:mm',
	showTimeSelect,
	dateFormat = showTimeSelect ? 'dd.MM.yyyy - HH:mm' : 'dd.MM.yyyy',
	placeholderText = i18n.t('general.select_date'),
	selected = null,
	onChange,
	...rest
}: Props) => {
	return (
		// @ts-expect-error aaaa types changes but these still work
		<ReactDatePicker
			isClearable
			calendarStartDay={1}
			onChange={onChange}
			selected={selected}
			timeFormat={timeFormat}
			dateFormat={dateFormat}
			placeholderText={placeholderText}
			showTimeSelect={showTimeSelect}
			shouldCloseOnSelect
			popperPlacement="top"
			{...rest}
		/>
	);
};
